var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"game-info-detail"},[_c('div',{staticClass:"game-info-detail-wrap"},[_c('navBar',{attrs:{"useTitle":_vm.$padFalg == 'other',"callBack":_vm.goList,"title":"百科"}}),_c('div',{staticClass:"game-info-main"},[_c(_vm.currentComponent,{tag:"component",attrs:{"detailData":_vm.detailData}})],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }